import { genderSelectOptions } from '@application/utils';
import { useTranslation } from '@presentation/utils';
import { Form, useFormikContext } from 'formik';
import type { FC } from 'react';
import { Button } from '../Button';
import { Card } from '../Card';
import { InputDateField } from '../InputDateField';
import { InputField } from '../InputField';
import { InputLabel } from '../InputLabel';
import { InputRadioField } from '../InputRadioField';
import { InputSelectField } from '../InputSelectField';
import { InputWrapper } from '../InputWrapper';
import { Modal } from '../Modal';
import { ModalCloseButton } from '../ModalCloseButton';
import { SectionTitle } from '../Section';
import type {
  MtApplicationsOwnModalActionType,
  MtApplicationsOwnModalFormValues,
  MtApplicationsOwnModalProps,
} from './types';

export * from './types';

export const MtApplicationsOwnModal: FC<MtApplicationsOwnModalProps> = (props) => {
  const { isSubmitting, values } = useFormikContext<MtApplicationsOwnModalFormValues>();
  const { modal, formOptions, isLoading } = props;

  const actionIsOwn = values?.action === 'own';

  const { translate } = useTranslation();

  return (
    <Modal {...modal}>
      <Card size="small" isModal>
        <ModalCloseButton modal={modal} />
        <SectionTitle>{translate('common.modals.own.title')}</SectionTitle>
        <Form>
          {formOptions.showActionsField && (
            <InputWrapper>
              <InputLabel required>{translate('common.inputs.action.label')}</InputLabel>
              <InputRadioField<MtApplicationsOwnModalActionType>
                name="action"
                grow
                options={formOptions.actions}
              />
            </InputWrapper>
          )}
          {formOptions.showNameField && (
            <InputWrapper>
              <InputLabel required>{translate('common.inputs.animalName.label')}</InputLabel>
              <InputField name="name" />
            </InputWrapper>
          )}
          <InputWrapper>
            <InputLabel required>{translate('common.inputs.breed.label')}</InputLabel>
            <InputSelectField name="breed" options={formOptions.breedIds} relativeDropdown />
          </InputWrapper>

          <InputWrapper>
            <InputLabel required={actionIsOwn}>
              {translate('common.inputs.birthday.label')}
            </InputLabel>
            <InputDateField name="birthday" disableFutureDates relativeDropdown />
          </InputWrapper>

          <InputWrapper>
            <InputLabel required={actionIsOwn}>
              {translate('common.inputs.gender.label')}
            </InputLabel>
            <InputSelectField
              name="gender"
              options={genderSelectOptions(translate)}
              relativeDropdown
            />
          </InputWrapper>

          <InputWrapper split>
            <Button color="blue" outlined onClick={modal.onCloseClick} disabled={isSubmitting}>
              {translate('common.buttons.cancel')}
            </Button>
          </InputWrapper>
          <InputWrapper split last>
            <Button color="blue" disabled={isSubmitting} type="submit" loading={isLoading}>
              {translate('common.buttons.confirm')}
            </Button>
          </InputWrapper>
        </Form>
      </Card>
    </Modal>
  );
};
